// Notifiche push appuntamenti - richiede permesso e schedula via setTimeout
// (funziona finché il browser è aperto; su mobile installa come PWA e tieni aperta)

const STORAGE_KEY = "cantiere360_scheduled_notifs";

export async function requestNotificationPermission() {
  if (typeof window === "undefined" || !("Notification" in window)) return false;
  if (Notification.permission === "granted") return true;
  if (Notification.permission === "denied") return false;
  const perm = await Notification.requestPermission();
  return perm === "granted";
}

export function hasPermission() {
  return typeof window !== "undefined" && "Notification" in window && Notification.permission === "granted";
}

export function scheduleAppuntamento(a, minutiPrima = 60) {
  if (!hasPermission()) return;
  const start = new Date(a.data_ora).getTime();
  const notifTime = start - minutiPrima * 60 * 1000;
  const now = Date.now();
  const delta = notifTime - now;
  if (delta <= 0 || delta > 24 * 60 * 60 * 1000 * 7) return; // solo nei prossimi 7gg
  const key = `notif-${a.id}`;
  const scheduled = JSON.parse(localStorage.getItem(STORAGE_KEY) || "{}");
  if (scheduled[key] && scheduled[key] === notifTime) return;
  setTimeout(() => {
    try {
      new Notification(`⏰ ${a.titolo || "Appuntamento"}`, {
        body: `Tra ${minutiPrima} minuti${a.luogo ? ` · ${a.luogo}` : ""}${a.descrizione ? `\n${a.descrizione}` : ""}`,
        tag: a.id,
        requireInteraction: true,
      });
    } catch {}
  }, delta);
  scheduled[key] = notifTime;
  localStorage.setItem(STORAGE_KEY, JSON.stringify(scheduled));
}

export function scheduleAll(appuntamenti, minutiPrima = 60) {
  for (const a of appuntamenti) scheduleAppuntamento(a, minutiPrima);
}
